<template>
    <div style="margin:0 auto;">
        <section class="service_top_section text-center">
            <div class="container-fluid">
                <div class="service_top_section__img_section text-center" :style="{'width': '100%'}">
                    <div class="row">
                        <div class="col-md-4 col-xl-4 col-lg-4 col-sm-4">
                            <ul class="list-group dashboard-sidebar-mobile-width">
                                <li class="list-group-item text-white bg-success d-flex justify-content-between" style="font-weight:bolder; text-align:center !important;">
                                   <i class="fa fa-bars" aria-hidden="true"></i> Menu
                                   <i class="fa fa-angle-double-down" aria-hidden="true"></i>
                                </li>
                                <li @click="dashboard()" class="list-group-item d-flex align-items-left menu-item-dashboard">
                                   <i class="fa fa-caret-right mr-2" aria-hidden="true"></i> Dashboard
                                </li>
                                <li @click="purchaseOrder()" class="list-group-item d-flex  align-items-left menu-item-dashboard">
                                   <i class="fa fa-caret-right mr-2" aria-hidden="true"></i> My Purchase Orders
                                </li>
                                <li @click="sellOrder()"  class="list-group-item d-flex  align-items-left menu-item-dashboard">
                                   <i class="fa fa-caret-right mr-2" aria-hidden="true"></i> My Sell Orders
                                </li>
                                <li @click="profile()"   class="list-group-item d-flex jalign-items-left menu-item-dashboard">
                                   <i class="fa fa-caret-right mr-2" aria-hidden="true"></i> My Profile
                                </li>
                                <li @click="changePassword()"  class="list-group-item d-flex align-items-left menu-item-dashboard">
                                   <i class="fa fa-caret-right mr-2" aria-hidden="true"></i> Change Password
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>  
            </div>
        </section>
    </div>         
</template>

<script>
    export default {
        name: "SiteSidebar",
        methods: {
            dashboard: function() { 
                this.$router.push({ 
                    name: 'Dashboard'
                });  
            },
            purchaseOrder: function() { 
                this.$router.push({
                    name: 'PurchaseOrder'
                });  
            },
            sellOrder: function() { 
                this.$router.push({
                    name: 'SellOrder'
                });  
            },
            profile: function() { 
                this.$router.push({
                    name: 'UserProfile'
                });  
            },
            changePassword: function() { 
                this.$router.push({
                    name: 'ChangePassword'
                });  
            },
        }
    }
</script>